import React from 'react';
import { FormControl } from 'react-bootstrap';
import {
  normalizeServerBaseLicenceKeyInput,
  normalizeServerUnlimitedLicenceKeyInput,
  normalizeViewerLicenceKeyInput,
  normalizeViewerProLiteLicenceKeyInput
} from '../common/normalizeKeyInput';

class LicenseKeyInputNormalized extends React.Component {

  constructor(props) {
    super(props);
    this.state = { value: '' };
    this.cursorPosition = 0;
    this.inputRef = null;
  }

  updateState = ({ normalizedValue: normalizedLicenseKey, cursorPosition }) => {
    const { onChange } = this.props;
    this.cursorPosition = cursorPosition;
    onChange(normalizedLicenseKey);
    this.setState({ value: normalizedLicenseKey });
  };

  handleChange = (e) => {
    const { productName, licKeyType } = this.props;

    const isPacsServerProductSelected = productName === 'pacs_server';
    const isBaseLicKeyTypeSelected = isPacsServerProductSelected && licKeyType === '00';
    const isUnlimitedLicKeyTypeSelected = isPacsServerProductSelected && licKeyType === 'ZZ';

    if (isPacsServerProductSelected) {
      if (isBaseLicKeyTypeSelected) {
        const normalizeData = normalizeServerBaseLicenceKeyInput(e.nativeEvent);
        if (normalizeData === null) return;
        this.updateState(normalizeData);

      } else if (isUnlimitedLicKeyTypeSelected) {
        const normalizedData = normalizeServerUnlimitedLicenceKeyInput(e.nativeEvent);
        if (normalizedData === null) return;
        this.updateState(normalizedData);
      }
    } else if (productName === 'viewer') {
      const normalizeData = normalizeViewerLicenceKeyInput(e.nativeEvent);
      if (normalizeData === null) return;
      this.updateState(normalizeData);

    } else {
      const normalizeData = normalizeViewerProLiteLicenceKeyInput(e.nativeEvent);
      if (normalizeData === null) return;
      this.updateState(normalizeData);
    }
  };

  componentDidUpdate() {
    const index = this.cursorPosition;
    this.inputRef.setSelectionRange(index, index);
  }

  render() {
    const { value: licenseKey } = this.state;

    return (
      <FormControl inputRef={(ref) => {this.inputRef = ref}}
                   value={licenseKey}
                   onChange={this.handleChange}
                   type="text"
      />
    );
  }
}

export default LicenseKeyInputNormalized;



// WEBPACK FOOTER //
// ./src/components/licenseKeyInputNormalized.js